import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import { StorageService } from '../../../shared/security/StorageService';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { BrokerAuditDataModel } from '../../../model/brokerAuditDataModel';
import { SubmitBrokerAuditDataResponseModel } from '../../../model/submitBrokerAuditDataResponseModel';
import { MessageModel } from '../../../model/models';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { SubmitBrokerAuditDataRequestModel } from '../../../model/submitBrokerAuditDataRequestModel';
import { BrokerDataDeclarationSectionEnum } from '../../../model/enumModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import * as $ from 'jquery';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { NgForm, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BrokerAuditDeclarationSaveDataService } from '../broker-audit-declaration-save-data.service';
import { Subscription } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-enter-data-brokerage-info',
  templateUrl: './enter-data-brokerage-info.component.html',
  styleUrls: ['./enter-data-brokerage-info.component.css']
})
export class EnterDataBrokerageInfoComponent implements OnInit, OnDestroy {

  workflow: WorkflowModel = new WorkflowModel();
  startFunction: StartFunctionResponseModel;
  brokerAuditDataModel: BrokerAuditDataModel = new BrokerAuditDataModel();
  submitBrokerAuditDataRequestModel: SubmitBrokerAuditDataRequestModel = new SubmitBrokerAuditDataRequestModel();

  userMessages: Array<MessageModel> = [];

  badForm: FormGroup;

  residence: FormControl= this.fb.control('', Validators.required);
  numLicensedEmployees: FormControl = this.fb.control('', Validators.compose([Validators.required]));
  numAssociateBrokers: FormControl = this.fb.control('', Validators.required);
  numUnlicensedFullTimeEmployees: FormControl = this.fb.control('', Validators.required);
  numUnlicensedPartTimeEmployees: FormControl = this.fb.control('', Validators.required);
  numRealEstateTeams: FormControl = this.fb.control('', Validators.required);
  numSalesTransactions: FormControl = this.fb.control('', Validators.required);
  numResidentialLeaseTransactions: FormControl = this.fb.control('', Validators.required);
  numCommercialLeaseTransactions: FormControl = this.fb.control('', Validators.required);
  errorOmissionIns: FormControl = this.fb.control('', Validators.required);
  maintainsGeneralTrustAccounts: FormControl = this.fb.control('', Validators.required);
  maintainsPropertyManagementTrustAccounts: FormControl = this.fb.control('', Validators.required);
  utilizesOffSiteStorageLocations: FormControl = this.fb.control('', Validators.required);
  utilizesTransactionManagementSystems: FormControl = this.fb.control('', Validators.required);
  utilizesPropertyManagementAccounting: FormControl = this.fb.control('', Validators.required);
  utilizesOwnedElectronicStorage: FormControl = this.fb.control('', Validators.required);
  utilizesNotOwnedElectronicStorage: FormControl = this.fb.control('', Validators.required);
  residentialRealEstate: FormControl = this.fb.control('');
  commercialSales: FormControl = this.fb.control('');
  referralBrokerage: FormControl = this.fb.control('');
  businessBrokerage: FormControl = this.fb.control('');
  farmAndRanch: FormControl = this.fb.control('');
  residentialPropMgmt: FormControl = this.fb.control('');
  commercialPropMgmt: FormControl = this.fb.control('');
  newHomeSubdivision: FormControl = this.fb.control('');
  otherSubdivision: FormControl = this.fb.control('');
  timeshare: FormControl = this.fb.control('');
  other: FormControl = this.fb.control('');
  otherText: FormControl = this.fb.control('');

  SaveDataSubscription : Subscription = new Subscription();

  constructor(private fb: FormBuilder, private router: Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private storageService: StorageService,
    private startFunctionService: StartFunctionService,
    private spinner: SpinnerService,
    private currentPageWatcher: CurrentPageWatcherService, 
    private brokerAuditDeclarationSaveDataService : BrokerAuditDeclarationSaveDataService) {

  }

  ngOnInit() {

    this.badForm = this.fb.group({
      residence: this.residence,
      numLicensedEmployees: this.numLicensedEmployees,
      numAssociateBrokers: this.numAssociateBrokers,
      numUnlicensedFullTimeEmployees: this.numUnlicensedFullTimeEmployees,
      numUnlicensedPartTimeEmployees: this.numUnlicensedPartTimeEmployees,
      numRealEstateTeams: this.numRealEstateTeams,
      numSalesTransactions: this.numSalesTransactions,
      numResidentialLeaseTransactions: this.numResidentialLeaseTransactions,
      numCommercialLeaseTransactions: this.numCommercialLeaseTransactions,
      errorOmissionIns: this.errorOmissionIns,
      maintainsGeneralTrustAccounts: this.maintainsGeneralTrustAccounts,
      maintainsPropertyManagementTrustAccounts: this.maintainsPropertyManagementTrustAccounts,
      utilizesOffSiteStorageLocations: this.utilizesOffSiteStorageLocations,
      utilizesTransactionManagementSystems: this.utilizesTransactionManagementSystems,
      utilizesPropertyManagementAccounting: this.utilizesPropertyManagementAccounting,
      utilizesOwnedElectronicStorage: this.utilizesOwnedElectronicStorage,
      utilizesNotOwnedElectronicStorage: this.utilizesNotOwnedElectronicStorage,
      residentialRealEstate: this.residentialRealEstate,
      commercialSales: this.commercialSales,
      referralBrokerage: this.referralBrokerage,
      businessBrokerage: this.businessBrokerage,
      farmAndRanch: this.farmAndRanch,
      residentialPropMgmt: this.residentialPropMgmt,
      commercialPropMgmt: this.commercialPropMgmt,
      newHomeSubdivision: this.newHomeSubdivision,
      otherSubdivision: this.otherSubdivision,
      timeshare: this.timeshare,
      other: this.other,
      otherText: this.otherText,

    });
    this.startFunction = this.storageService.getStartFunctionData();

    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.workflow = this.startFunction.Workflow;
    }

    this.submitBrokerAuditDataRequestModel.WorkflowID = this.workflow.WorkflowID;
    this.submitBrokerAuditDataRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex;
    if (this.brokerAuditDeclarationService.brokerAuditDataModel == null || this.brokerAuditDeclarationService.brokerAuditDataModel == undefined) {
      this.brokerAuditDeclarationService.getBrokerAuditDeclarationData(this.workflow.WorkflowID).subscribe(
        (badData: BrokerAuditDataModel) => {
          this.brokerAuditDataModel = badData;
          this.brokerAuditDeclarationService.brokerAuditDataModel = this.brokerAuditDataModel;
          this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdated().emit(this.brokerAuditDataModel.LastUpdated);

        },
        err => {
          console.log(err);
          if (err.status == 404) {
            this.brokerAuditDataModel = new BrokerAuditDataModel();
            this.brokerAuditDeclarationService.brokerAuditDataModel = this.brokerAuditDataModel;
            this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdated().emit(null);
            this.spinner.hide();
          }
        }
      );
    }

    else {
      this.brokerAuditDataModel = this.brokerAuditDeclarationService.brokerAuditDataModel;

    }

    //save current values
    this.SaveDataSubscription =this.brokerAuditDeclarationService.getNotifySaveData().subscribe((data:Boolean)=>{
      if(data == true){
        if (this.badForm.valid) {
          this.submitBrokerAuditDataRequestModel.SubmitAsDraft = true;
          this.submitBrokerAuditDataRequestModel.BrokerAuditData = this.brokerAuditDataModel;
          this.brokerAuditDeclarationSaveDataService.saveBAD(this.submitBrokerAuditDataRequestModel);
        }
        else {
          this.handleBadFormErrors(this.badForm);
        }
      }
    })

  }


  onContinue() {

    this.currentPageWatcher.clearUserMessage();
    if (this.badForm.valid) {
      //get sections from brokerAuditDataModel
      this.getBADSectionList();

      //next section = first section in the list = min number of this.brokerAuditDeclarationService.brokerDataDeclarationSectionList
      let nextSection = Math.min.apply(null, this.brokerAuditDeclarationService.brokerDataDeclarationSectionList);

     

            switch (nextSection) {
              case 1: {
                this.router.navigate(['/section1BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));
                break;
              }
              case 2: {
                this.router.navigate(['/section2BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }
              case 3: {
                this.router.navigate(['/section3BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }
              case 4: {
                this.router.navigate(['/section4BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }
              case 5: {
                this.router.navigate(['/section5BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }
              case 6: {
                this.router.navigate(['/section6BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }

              case 7: {
                this.router.navigate(['/section7BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }

              case 8: {
                this.router.navigate(['/section8BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));

                break;
              }

              case 9: {
                this.router.navigate(['/section9BaData']).then(()=>this.currentPageWatcher.sendStepMessage(null));
                break;
              }
              default: {
                this.submitBADData();
                break;
              }
            }
         
    }
    else {
      this.handleBadFormErrors(this.badForm);
    }
  }


  getBADSectionList() {
    this.brokerAuditDeclarationService.brokerDataDeclarationSectionList = [];

    if (this.brokerAuditDataModel.MaintainsGeneralTrustAccounts) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_1);
    }
    if (this.brokerAuditDataModel.MaintainsPropertyManagementTrustAccounts) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_2);
    }
    if (this.brokerAuditDataModel.ResidentialPropMgmt) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_3);
    }
    if (this.brokerAuditDataModel.CommercialPropMgmt) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_4);
    }
    if (this.brokerAuditDataModel.UtilizesOffSiteStorageLocations) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_5);
    }
    if (this.brokerAuditDataModel.UtilizesTransactionManagementSystems) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_6);
    }
    if (this.brokerAuditDataModel.UtilizesPropertyManagementAccountingSystems) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_7);
    }
    if (this.brokerAuditDataModel.UtilizesOwnedElectronicStorageSystems) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_8);
    }
    if (this.brokerAuditDataModel.UtilizesNotOwnedElectronicStorageSystems) {
      this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.push(BrokerDataDeclarationSectionEnum.BAD_SECTION_9);
    }
  }

  handleBadFormErrors(badForm: FormGroup) {
    let yesNoQuestionsErrorMessage: MessageModel = {};
    yesNoQuestionsErrorMessage.Alert = 3;
    yesNoQuestionsErrorMessage.Description = "You must answer all Yes/No questions.";

    let numLicensedEmployeesErrorMessage: MessageModel = {};
    numLicensedEmployeesErrorMessage.Alert = 3;
    numLicensedEmployeesErrorMessage.Description = "Number of licensed employees is required.";

    let numAssociateBrokersErrorMessage: MessageModel = {};
    numAssociateBrokersErrorMessage.Alert = 3;
    numAssociateBrokersErrorMessage.Description = "Number of associate brokers with delegated broker duties is required.";

    let numUnlicensedFullTimeEmployeesErrorMessage: MessageModel = {};
    numUnlicensedFullTimeEmployeesErrorMessage.Alert = 3;
    numUnlicensedFullTimeEmployeesErrorMessage.Description = "Number of unlicensed full-time employees is required.";

    let numUnlicensedPartTimeEmployeesErrorMessage: MessageModel = {};
    numUnlicensedPartTimeEmployeesErrorMessage.Alert = 3;
    numUnlicensedPartTimeEmployeesErrorMessage.Description = " Number of unlicensed part-time employees is required.";

    let numRealEstateTeamsErrorMessage: MessageModel = {};
    numRealEstateTeamsErrorMessage.Alert = 3;
    numRealEstateTeamsErrorMessage.Description = "Number of real estate teams associated with the brokerage is required.";

    let numSalesTransactionsErrorMessage: MessageModel = {};
    numSalesTransactionsErrorMessage.Alert = 3;
    numSalesTransactionsErrorMessage.Description = "Average number of Sales transactions handled per year is required.";

    let numResidentialLeaseTransactionsErrorMessage: MessageModel = {};
    numResidentialLeaseTransactionsErrorMessage.Alert = 3;
    numResidentialLeaseTransactionsErrorMessage.Description = "Average number of Residential Lease transactions handled per year is required.";

    let numCommercialLeaseTransactionsErrorMessage: MessageModel = {};
    numCommercialLeaseTransactionsErrorMessage.Alert = 3;
    numCommercialLeaseTransactionsErrorMessage.Description = "Average number of Commercial Lease transactions handled per year is required.";

    let otherTextErrorMessage: MessageModel = {};
    otherTextErrorMessage.Alert = 3;
    otherTextErrorMessage.Description = "Other brokerage conduct is required.";

    //check form errors
    if ((badForm.controls.residence.errors != null && badForm.controls.residence.errors.required)
      || (badForm.controls.errorOmissionIns.errors != null && badForm.controls.errorOmissionIns.errors.required)
      || (badForm.controls.maintainsGeneralTrustAccounts.errors != null && badForm.controls.maintainsGeneralTrustAccounts.errors.required)
      || (badForm.controls.maintainsPropertyManagementTrustAccounts.errors != null && badForm.controls.maintainsPropertyManagementTrustAccounts.errors.required)
      || (badForm.controls.utilizesOffSiteStorageLocations.errors != null && badForm.controls.utilizesOffSiteStorageLocations.errors.required)
      || (badForm.controls.utilizesTransactionManagementSystems.errors != null && badForm.controls.utilizesTransactionManagementSystems.errors.required)
      || (badForm.controls.utilizesPropertyManagementAccounting.errors != null && badForm.controls.utilizesPropertyManagementAccounting.errors.required)
      || (badForm.controls.utilizesOwnedElectronicStorage.errors != null && badForm.controls.utilizesOwnedElectronicStorage.errors.required)
      || (badForm.controls.utilizesNotOwnedElectronicStorage.errors != null && badForm.controls.utilizesNotOwnedElectronicStorage.errors.required)) {
      this.userMessages.push(yesNoQuestionsErrorMessage);
    }

    if (badForm.controls.numLicensedEmployees.errors != null && (badForm.controls.numLicensedEmployees.errors.required || badForm.controls.numLicensedEmployees.errors.pattern)) {
      this.userMessages.push(numLicensedEmployeesErrorMessage);
    }

    if (badForm.controls.numAssociateBrokers.errors != null && (badForm.controls.numAssociateBrokers.errors.required || badForm.controls.numAssociateBrokers.errors.pattern)) {
      this.userMessages.push(numAssociateBrokersErrorMessage);
    }

    if (badForm.controls.numUnlicensedFullTimeEmployees.errors != null && (badForm.controls.numUnlicensedFullTimeEmployees.errors.required || badForm.controls.numUnlicensedFullTimeEmployees.errors.pattern)) {
      this.userMessages.push(numUnlicensedFullTimeEmployeesErrorMessage);
    }

    if (badForm.controls.numUnlicensedPartTimeEmployees.errors != null && (badForm.controls.numUnlicensedPartTimeEmployees.errors.required || badForm.controls.numUnlicensedPartTimeEmployees.errors.pattern)) {
      this.userMessages.push(numUnlicensedPartTimeEmployeesErrorMessage);
    }

    if (badForm.controls.numRealEstateTeams.errors != null && (badForm.controls.numRealEstateTeams.errors.required || badForm.controls.numRealEstateTeams.errors.pattern)) {
      this.userMessages.push(numRealEstateTeamsErrorMessage);
    }

    if (badForm.controls.numSalesTransactions.errors != null && (badForm.controls.numSalesTransactions.errors.required || badForm.controls.numSalesTransactions.errors.pattern)) {
      this.userMessages.push(numSalesTransactionsErrorMessage);
    }

    if (badForm.controls.numResidentialLeaseTransactions.errors != null && (badForm.controls.numResidentialLeaseTransactions.errors.required || badForm.controls.numResidentialLeaseTransactions.errors.pattern)) {
      this.userMessages.push(numResidentialLeaseTransactionsErrorMessage);
    }

    if (badForm.controls.numCommercialLeaseTransactions.errors != null && (badForm.controls.numCommercialLeaseTransactions.errors.required || badForm.controls.numCommercialLeaseTransactions.errors.pattern)) {
      this.userMessages.push(numCommercialLeaseTransactionsErrorMessage);
    }

    if (badForm.controls.otherText.errors != null && badForm.controls.otherText.errors.required) {
      this.userMessages.push(otherTextErrorMessage);
    }
    this.currentPageWatcher.sendUserMessages(this.userMessages);
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.userMessages = [];
  }

  submitBADData() {
    this.submitBrokerAuditDataRequestModel.BrokerAuditData = this.brokerAuditDataModel;
    this.submitBrokerAuditDataRequestModel.SubmitAsDraft = false;
    this.brokerAuditDeclarationService.submitBrokerAuditDeclarationData(this.submitBrokerAuditDataRequestModel)
      .subscribe((response: SubmitBrokerAuditDataResponseModel) => {
        console.log("server response : : ", response);

        response.UserMessages.forEach(msg => {
          this.userMessages.push(msg);
        });
        console.log(this.userMessages);
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (response.Summary == 0) {
          this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;

          console.log("this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel : : ", this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel);
          //save startFunction with updated workflow in localstorage
          this.brokerAuditDeclarationService.updateStartFunction(this.startFunction);

          this.router.navigate(['/questionnaireAuditDeclaration']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
             //send last updated date to the saveDataComponent 
            this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdated().emit(this.brokerAuditDataModel.LastUpdated);

          });
         
          this.userMessages = [];
        }
        if (response.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];

        }

        if (response.Summary == 2) {
          this.currentPageWatcher.displayUserMessage = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      })
  }

  ngOnDestroy(): void {
    if(this.currentPageWatcher.displayUserMessage == false){
      this.currentPageWatcher.clearUserMessage();
    }

    this.SaveDataSubscription.unsubscribe();

  }

  back() {
    this.router.navigate(['/startAuditDeclaration']).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(false);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/enter-data-brokerage-info/enter-data-brokerage-info.component.ts